/* eslint-disable no-useless-escape */
import { DOMAIN } from './messages';
import { domainRegex } from '../constants';

const domainValidation = (fields, key, criteria) => {
  const field = fields[key];
  const message = criteria.message || DOMAIN;
  return domainRegex.test(field) ? null : message;
};
export default domainValidation;
